const axios = require('@/lib/axios').default

export function getAlbum(id){
  return axios.get(`/mirror/album/${id}`)
}
export function createAlbum(data){
  return axios.post('/mirror/album', data)
}
export function postAlbumTrack(track){
  return axios.post(`/mirror/album/${track.aid}`, track)
}
export function getOwnedAlbums(page){
  return axios.get('/mirror/albums', {
    params: {
      p: page
    }
  })
}
